import React, { Component } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";

import styles from "./styles.scss";
import { shouldUpdate } from "../../../../utils";

let count = 0;
const idPrefix = "sampleSummaryTable";

@CSSModules(styles, { allowMultiple: true })
class SampleSummaryTable extends Component {
	constructor(props) {
		super(props);
		this.props.initComponent(this.props.id, this.props.component);
	}
	render() {
		if (!this.props.componentData) {
			return null;
		}
		return (
			<div styleName="component-wrapper">
				<div styleName="component-title">{this.props.component.chartTitle || "Summary of Samples"}</div>
				<table styleName="occurences-table">
					<thead>
						<tr>
							<td>Variable</td>
							<td>Total Samples</td>
							<td>Samples Above</td>
							<td>Samples Below</td>
							<td>Total Hours</td>
							<td>Hours Outside of Range</td>
							<td>% Hours Outside of Range</td>
							<td>% Samples Outside of Range</td>
						</tr>
					</thead>
					<tbody>
						{this.props.componentData.sampleSummaries.map((sampleSummary, index) => (
							<tr key={index}>
								<td>{sampleSummary.pointName}</td>
								<td>{sampleSummary.totalSamples}</td>
								<td>{sampleSummary.samplesAbove}</td>
								<td>{sampleSummary.samplesBelow}</td>
								<td>{sampleSummary.totalHours}</td>
								<td>{sampleSummary.hoursOutsideRange}</td>
								<td>{sampleSummary.percentageHoursOutsideRange}</td>
								<td>{sampleSummary.percentageSamplesOutsideRange}</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	setup() {
		this.props.loadData(this.props.id, this.props.component, this.props.timePeriod, this.props.onLoadComplete);
	}

	componentDidMount() {
		this.setup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.componentData != this.props.componentData) {
			return true;
		} else if (prevProps.component != this.props.component || prevProps.timePeriod != this.props.timePeriod) {
			this.setup();
			return false;
		} else {
			return false;
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
	}
}

const bindAction = dispatch => {
	return {
		loadData: (id, component, timePeriod, onLoadComplete) => dispatch(actions.loadData(id, component, timePeriod, onLoadComplete)),
		initComponent: (id, component) => dispatch(actions.initComponent(id, component))
	};
};

const mapStateToProps = (state, ownProps) => ({
	componentData: state.samplesummarytable.instances[ownProps.id]
});

//do this to merge classes
export default class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			wrapped: null
		};
		this.id = idPrefix + count;
		count++;
	}

	componentWillMount() {
		this.setState({
			wrapped: connect(
				mapStateToProps,
				bindAction
			)(SampleSummaryTable)
		});
	}

	render() {
		const Elem = this.state.wrapped;
		return <Elem {...this.props} id={this.id} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Tables/SampleSummaryTable/SampleSummaryTable.js